function BanniereTitre({ titre, liste }) {
  const elements = liste.map((element, index) => (
    <li key={index}>{element}</li>
  ));

  return (
    <div className="relative">
      {/* Images décoratives masquées en mobile */}
      <img src="./images/bulleEquipe1.avif" alt="Bulle équipe 1" className="hidden lg:block absolute top-4 right-[22vw] h-[176px]" />
      <img src="./images/bulleEquipe2.avif" alt="Bulle équipe 2" className="hidden lg:block absolute top-[109px] right-[2vw] h-[176px]" />
      
      <div className="dark:bg-bleu-gris min-h-[300px] h-auto flex flex-col justify-center p-12">
        <div className="text-gris-sombre text-2xl md:text-3xl font-semibold text-center md:text-left">
          <p>i2c vous accompagne dans</p>
          <div className="flex flex-col md:flex-row gap-2 justify-center md:justify-start items-center">
            <p>{titre}</p>
            <div className="h-[36px] overflow-hidden">
              <ul className="text-bleu-je dark:text-bleu-sombre flex flex-col animate-slide-up leading-[36px]">{elements}</ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BanniereTitre;